"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_modal_1 = require("@doordash/component-modal");
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var App_1 = __importDefault(require("../../App/App"));
var RiskModal_1 = __importDefault(require("../../Common/RiskModal"));
var enums_1 = require("../../Common/utils/enums");
var useTracking_1 = __importDefault(require("../../Common/utils/useTracking"));
var VerifyCardTemplate_1 = __importDefault(require("../VerifyCardTemplate"));
var VerifyPaymentCard_1 = __importDefault(require("../VerifyPaymentCard"));
var VerifyPaymentCardContext_1 = require("../VerifyPaymentCardContext");
var VerifyPaymentCardStrings_1 = __importDefault(require("../VerifyPaymentCardStrings"));
var SecondCardModalTitle_1 = __importDefault(require("./SecondCardModalTitle"));
var SecondCardChallenge = function (_a) {
    var consumerInfo = _a.consumerInfo, defaultCard = _a.defaultCard, paymentConfig = _a.paymentConfig, orderCart = _a.orderCart, disableDismiss = _a.disableDismiss, stripeKey = _a.stripeKey;
    var _b = React.useContext(App_1["default"]), dispatch = _b.dispatch, state = _b.state;
    var _c = useTracking_1["default"](), trackLoad = _c.trackLoad, trackClose = _c.trackClose;
    React.useEffect(function () {
        trackLoad(orderCart.id);
    }, []);
    return (React.createElement(RiskModal_1["default"], { onCloseTracking: trackClose, primaryActionText: VerifyPaymentCardStrings_1["default"].verifyAndPlaceOrder(), renderContentHeader: function (_a) {
            var subtitle = _a.subtitle, title = _a.title;
            return (React.createElement(SecondCardModalTitle_1["default"], { subtitle: subtitle, title: title }));
        }, disableDismiss: disableDismiss, size: component_modal_1.Modal.Sizes.Medium, subtitle: VerifyPaymentCardStrings_1["default"].cardVerifyDescription(), title: VerifyPaymentCardStrings_1["default"].cardVerifyTitle() },
        React.createElement(VerifyPaymentCardContext_1.VerifyPaymentCardProvider, { consumerInfo: consumerInfo, defaultCard: defaultCard, paymentConfig: paymentConfig, orderCart: orderCart, stripeKey: stripeKey },
            React.createElement(design_language_1.StackChildren, null,
                React.createElement(VerifyCardTemplate_1["default"], null),
                React.createElement(VerifyPaymentCard_1["default"], { onClose: function () {
                        dispatch({ type: enums_1.RiskActions.Reset });
                        if (typeof state.onSuccess === 'function') {
                            state.onSuccess();
                        }
                    } }),
                React.createElement(design_language_1.Text, { display: design_language_1.Text.DisplayModes.Inline, size: design_language_1.Text.Sizes.S14 }, VerifyPaymentCardStrings_1["default"].note() + " "),
                React.createElement(design_language_1.Text, { display: design_language_1.Text.DisplayModes.Inline, styles: design_language_1.Text.Styles.SectionSubtext }, VerifyPaymentCardStrings_1["default"].cardVerifyNote())))));
};
exports["default"] = SecondCardChallenge;
